import { render, staticRenderFns } from "./my-icon.vue?vue&type=template&id=a8392f50"
import script from "./my-icon.vue?vue&type=script&lang=js"
export * from "./my-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports